import React from "react";

function Navbar() {
  const scrollToSection = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="container">
      <nav className="navbar mt-5 pb-5 d-flex justify-content-between flex-wrap">
        <a href="#top" onClick={scrollToSection("top")} className="fs-4">
          Tanveer Singh
        </a>
        <div className="nav-links">
          <a href="#projects" onClick={scrollToSection("projects")} className="p-3">
            Projects
          </a>
          <a href="#contact" onClick={scrollToSection("contact")} className="p-3">
            Contact
          </a>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
